// Client-side mirror of the backend rule for POST /api/auth/change-password:
// at least 8 characters, with at least one letter and at least one number.

export const PASSWORD_MIN_LENGTH = 8;

export const PASSWORD_RULE_HINT = `At least ${PASSWORD_MIN_LENGTH} characters, including at least one letter and one number`;

const HAS_LETTER_REGEX = /[a-zA-Z]/;
const HAS_NUMBER_REGEX = /[0-9]/;

/**
 * Validate a new password against the backend rule.
 * Returns a user-facing error message, or null when the password is valid.
 */
export const getPasswordRuleError = (password: string): string | null => {
  if (!password || password.length < PASSWORD_MIN_LENGTH) {
    return `Password must be at least ${PASSWORD_MIN_LENGTH} characters long`;
  }
  if (!HAS_LETTER_REGEX.test(password)) {
    return 'Password must contain at least one letter';
  }
  if (!HAS_NUMBER_REGEX.test(password)) {
    return 'Password must contain at least one number';
  }
  return null;
};
